module.exports = __webpack_public_path__ + "img/icho_bg.41dac512.png";